import { render, staticRenderFns } from "./ApiConfiguration.vue?vue&type=template&id=4f4286d8&"
import script from "./ApiConfiguration.vue?vue&type=script&lang=ts&"
export * from "./ApiConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./ApiConfiguration.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports